(()=>{
if(window.MOGA_OVERVIEW_LOADED)return;
window.MOGA_OVERVIEW_LOADED=true;

const n=v=>{const x=parseFloat(String(v??'').replace(/[^0-9,.-]/g,'').replace(',','.'));return Number.isFinite(x)?x:0};
const money=v=>n(v).toLocaleString('lt-LT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';
const esc=v=>typeof escapeHtml==='function'?escapeHtml(v??''):String(v??'');
const premium=()=>!!window.MOGA_PLAN?.isPremium();
const today=()=>new Date().toISOString().slice(0,10);

let selectedPeriod='current';

function tracking(){
  try{return typeof getTrackingInfo==='function'?getTrackingInfo():[]}
  catch(e){return[]}
}
function allMonths(){
  return [...new Set(tracking().map(r=>String(r.date||'').slice(0,7)).filter(x=>/^\d{4}-\d{2}$/.test(x)))].sort().reverse();
}
function periodLabel(){
  if(selectedPeriod==='all')return'Visas laikotarpis';
  if(selectedPeriod==='current')return today().slice(0,7);
  return selectedPeriod;
}
function periodRows(rows){
  if(selectedPeriod==='all')return rows;
  const m=selectedPeriod==='current'?today().slice(0,7):selectedPeriod;
  return rows.filter(r=>String(r.date||'').slice(0,7)===m);
}
function ensureOverviewUi(){
  const sheet=document.getElementById('overviewSheet');
  if(!sheet)return;

  const help=sheet.querySelector('.purchase-help');
  if(help&&!document.getElementById('overviewPeriodBar')){
    const bar=document.createElement('div');
    bar.id='overviewPeriodBar';
    bar.className='overview-period-bar';
    bar.innerHTML=`
      <div class="overview-period-main">
        <span>RODOMAS LAIKOTARPIS</span>
        <select id="overviewPeriodSelect" onchange="setOverviewPeriod(this.value)"></select>
      </div>
      <div class="overview-period-total">
        <span>VISI PARDAVIMAI</span>
        <strong id="ovAllSales">0,00 €</strong>
        <small id="ovAllSalesMeta">0 SF</small>
      </div>
    `;
    help.insertAdjacentElement('afterend',bar);
  }

  if(!document.getElementById('mogaOverviewPeriodCss')){
    const st=document.createElement('style');
    st.id='mogaOverviewPeriodCss';
    st.textContent=`
      .overview-period-bar{
        display:grid;
        grid-template-columns:minmax(260px,1fr) minmax(220px,320px);
        gap:10px;
        margin:10px 0 14px;
      }
      .overview-period-main,.overview-period-total{
        border:1px solid #ddd;
        border-radius:var(--ui-radius);
        background:#fff;
        padding:11px 13px;
      }
      .overview-period-main{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
      }
      .overview-period-main span,.overview-period-total span{
        font-size:9px;
        color:#777;
        font-weight:800;
      }
      .overview-period-main select{
        min-width:190px;
        min-height:37px;
        border:1px solid #bbb;
        background:#fff!important;
        color:#111!important;
        border-radius:8px;
        padding:7px 9px;
        font-weight:800;
      }
      .overview-period-total{
        display:grid;
        grid-template-columns:1fr auto;
        align-items:center;
        gap:2px 10px;
      }
      .overview-period-total strong{
        grid-row:1/3;
        grid-column:2;
        font-size:20px;
      }
      .overview-period-total small{font-size:9px;color:#777}
      @media(max-width:800px){
        .overview-period-bar{grid-template-columns:1fr}
        .overview-period-main{align-items:stretch;flex-direction:column}
        .overview-period-main select{width:100%}
      }
    `;
    document.head.appendChild(st);
  }

  refreshOverviewPeriodOptions();
}
function refreshOverviewPeriodOptions(){
  const select=document.getElementById('overviewPeriodSelect');
  if(!select)return;
  const months=allMonths();
  const current=today().slice(0,7);
  const opts=[
    ['current',`Šis mėnuo (${current})`],
    ...months.filter(m=>m!==current).map(m=>[m,m]),
    ['all','Visas laikotarpis']
  ];
  select.innerHTML=opts.map(([v,l])=>`<option value="${esc(v)}">${esc(l)}</option>`).join('');
  if(opts.some(x=>x[0]===selectedPeriod))select.value=selectedPeriod;
  else{selectedPeriod='current';select.value='current'}
}
window.setOverviewPeriod=function(v){
  selectedPeriod=v||'current';
  render();
};

function salesStats(){
  const rows=periodRows(tracking());
  const total=rows.reduce((a,r)=>a+n(r.sum),0);
  const received=rows.reduce((a,r)=>a+(r.status==='Apmokėta'?n(r.sum):r.status==='Dalinai'?n(r.received):0),0);
  let cost=0;
  const prods=window.MOGA_INVENTORY?.products?.()||[];
  rows.forEach(r=>(r.items||[]).forEach(i=>{
    let c=n(i.cost);
    if(!c)c=n(prods.find(p=>p.name===i.name)?.cost);
    cost+=c*n(i.qty);
  }));
  return{rows,total,received,unpaid:Math.max(0,total-received),cost,gross:total-cost};
}
function inventoryStats(){
  const ps=window.MOGA_INVENTORY?.products?.()||[];
  const store=window.MOGA_INVENTORY?.getStore?.()||{settings:{}};
  const moves=window.MOGA_INVENTORY?.getMoves?.()||[];
  let value=0,units=0,alerts=0;

  ps.forEach(p=>{
    const r=window.MOGA_INVENTORY?.getRecord?.(p.inventoryId,false)||{qty:0,reserved:0,min:0,target:0};
    units+=n(r.qty);
    value+=n(r.qty)*n(p.cost);

    const cfg=store.settings||{};
    const selected=Array.isArray(cfg.lowStockSelected)&&cfg.lowStockSelected.includes(p.inventoryId);
    const tracked=(cfg.lowStockScope==='selected')
      ?selected
      :(n(r.min)>0||n(r.target)>0||n(r.qty)>0||n(r.reserved)>0||moves.some(m=>m.productId===p.inventoryId));

    if(!tracked)return;
    const st=window.MOGA_INVENTORY?.status?.(p,r);
    if(st&&['low','out'].includes(st.key))alerts++;
  });
  return{value,units,alerts};
}
function purchaseStats(){
  const os=window.MOGA_PURCHASES?.orders?.()||[];
  let debt=0,incoming=0;
  os.forEach(o=>{
    const lines=o.lines||[];
    if(!['draft','received','cancelled'].includes(o.status))incoming+=lines.reduce((a,l)=>a+Math.max(0,n(l.qty)-n(l.receivedQty)),0);
    const base=lines.reduce((a,l)=>a+n(l.qty)*n(l.unitCost)*(1-n(l.discount)/100),0);
    const net=Math.max(0,base-n(o.discount))+n(o.shipping)+n(o.otherCosts);
    const vat=o.pricesIncludeVat?0:net*n(o.vatRate)/100;
    const grand=net+vat;
    debt+=Math.max(0,grand-n(o.paidAmount));
  });
  return{debt,incoming,open:os.filter(o=>!['received','cancelled'].includes(o.status)).length};
}
function expenseStats(){
  const es=window.MOGA_EXPENSES?.load?.()||[];
  const rows=selectedPeriod==='all'
    ?es
    :es.filter(e=>String(e.date||'').slice(0,7)===(selectedPeriod==='current'?today().slice(0,7):selectedPeriod));
  return{
    total:rows.reduce((a,e)=>a+(window.MOGA_EXPENSES?.calc?.(e)?.total||0),0),
    unpaid:rows.filter(e=>e.status!=='paid').reduce((a,e)=>a+(window.MOGA_EXPENSES?.calc?.(e)?.total||0),0)
  };
}
function setPage(page){
  if(page!=='overview')return false;
  if(!premium()){alert('APŽVALGA prieinama MOGA SF PREMIUM plane.');return true}
  ['invoiceSheet','trackingSheet','statsSheet','warehouseSheet','purchaseSheet','expenseSheet','taskSheet','accountingSalesSheet'].forEach(id=>{
    const e=document.getElementById(id);if(!e)return;
    if(id==='invoiceSheet')e.style.display='none';else e.classList.remove('active')
  });
  document.getElementById('overviewSheet')?.classList.add('active');
  ['tabInvoice','tabTracking','tabStats','tabWarehouse','tabPurchases','tabExpenses','tabTasks','tabAccountingSales'].forEach(id=>document.getElementById(id)?.classList.remove('active'));
  document.getElementById('tabOverview')?.classList.add('active');
  render();
  return true;
}
const base=window.switchPage;
window.switchPage=function(page){
  document.getElementById('overviewSheet')?.classList.remove('active');
  document.getElementById('tabOverview')?.classList.remove('active');
  if(setPage(page))return;
  return base(page);
};

function render(){
  if(!premium())return;
  ensureOverviewUi();

  const s=salesStats(),i=inventoryStats(),p=purchaseStats(),e=expenseStats(),oper=s.gross-e.total;
  const all=tracking(),allSales=all.reduce((a,r)=>a+n(r.sum),0);
  const put=(id,v)=>{const el=document.getElementById(id);if(el)el.textContent=v};

  put('ovSales',money(s.total));
  put('ovReceived',money(s.received));
  put('ovUnpaid',money(s.unpaid));
  put('ovGross',money(s.gross));
  put('ovExpenses',money(e.total));
  put('ovOperating',money(oper));
  put('ovInventory',money(i.value));
  put('ovStockAlerts',i.alerts);
  put('ovIncoming',p.incoming);
  put('ovSupplierDebt',money(p.debt));
  put('ovOpenPo',p.open);
  put('ovInvoices',s.rows.length);
  put('ovAllSales',money(allSales));
  put('ovAllSalesMeta',`${all.length} SF · ${allMonths().length} mėn.`);

  const kpiLabels=document.querySelectorAll('#overviewSheet .overview-kpi > span');
  if(kpiLabels[0])kpiLabels[0].textContent=selectedPeriod==='all'?'Pardavimai':'Laikotarpio pardavimai';
  const kpiSmall=document.querySelectorAll('#overviewSheet .overview-kpi > small');
  if(kpiSmall[0])kpiSmall[0].textContent=periodLabel();
  if(kpiSmall[4])kpiSmall[4].textContent=periodLabel();
  if(kpiLabels[11])kpiLabels[11].textContent=selectedPeriod==='all'?'SF iš viso':'SF laikotarpiu';

  const notices=[];
  if(s.unpaid>0)notices.push(`Neapmokėtos klientų SF: ${money(s.unpaid)}`);
  if(p.debt>0)notices.push(`Neapmokėta tiekėjams: ${money(p.debt)}`);
  if(i.alerts>0)notices.push(`Sandėlio prekių reikia dėmesio: ${i.alerts}`);
  if(p.incoming>0)notices.push(`Pakeliui prekių: ${p.incoming} vnt.`);
  if(e.unpaid>0)notices.push(`Neapmokėtų veiklos išlaidų: ${money(e.unpaid)}`);

  const tasks=window.MOGA_TASKS?.load?.()||[];
  const taskOver=tasks.filter(t=>t.status!=='done'&&window.MOGA_TASKS?.state?.(t)==='overdue').length;
  const taskToday=tasks.filter(t=>t.status!=='done'&&window.MOGA_TASKS?.state?.(t)==='today').length;
  if(taskOver>0)notices.push(`Vėluojančių užduočių: ${taskOver}`);
  if(taskToday>0)notices.push(`Užduočių šiandien: ${taskToday}`);

  const alertsEl=document.getElementById('overviewAlerts');
  if(alertsEl)alertsEl.innerHTML=notices.length
    ?notices.map(x=>`<div class="overview-alert-item">${esc(x)}</div>`).join('')
    :'<div class="overview-all-good">Šiuo metu kritinių perspėjimų nėra.</div>';

  const months={};
  all.forEach(r=>{const m=String(r.date||'').slice(0,7);if(m)months[m]=(months[m]||0)+n(r.sum)});
  const recent=Object.entries(months).sort((a,b)=>a[0].localeCompare(b[0])).slice(-12);
  const mx=Math.max(1,...recent.map(x=>x[1]));
  const chart=document.getElementById('overviewSalesChart');
  if(chart)chart.innerHTML=recent.length
    ?recent.map(([m,v])=>`<div class="overview-chart-row"><span>${esc(m)}</span><div><i style="width:${v/mx*100}%"></i></div><b>${money(v)}</b></div>`).join('')
    :'<div class="purchase-empty">Pardavimų duomenų dar nėra.</div>';

  const top={};
  s.rows.forEach(r=>(r.items||[]).forEach(x=>{if(x.name)top[x.name]=(top[x.name]||0)+n(x.qty)}));
  const topEl=document.getElementById('overviewTopProducts');
  if(topEl)topEl.innerHTML=Object.entries(top).sort((a,b)=>b[1]-a[1]).slice(0,8)
    .map(([name,q])=>`<div class="overview-list-row"><span>${esc(name)}</span><b>${q.toLocaleString('lt-LT')} vnt.</b></div>`).join('')
    ||'<div class="purchase-empty">Pasirinktam laikotarpiui duomenų nėra.</div>';
}

window.renderOverview=render;
window.MOGA_OVERVIEW={render,setPeriod:v=>{selectedPeriod=v;render()}};
window.addEventListener('moga:plan-change',()=>setTimeout(render,0));
window.addEventListener('moga:data-ready',()=>setTimeout(render,0));
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render);
else render();
})();